import { useState } from 'react';
import { Card, CardContent, Input, Button, LoadingSpinner } from '../components/ui';
import { useAuth } from '../contexts/AuthContext';

export default function ChangePassword() {
  const { user, changePassword, logout } = useAuth();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError('');

    if (newPassword !== confirmPassword) {
      setError('New passwords do not match');
      return;
    }

    setLoading(true);
    const result = await changePassword(currentPassword, newPassword);
    setLoading(false);

    if (!result.success) {
      setError(result.error || 'Failed to change password');
    }
  };

  return (
    <div className="min-h-screen bg-dark-900 flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardContent>
          <h1 className="text-2xl font-bold text-white mb-2">Change Password</h1>
          <p className="text-dark-400 mb-2">Hi {user?.name || 'there'}, please update your password to continue.</p>
          <p className="text-dark-500 mb-6 text-sm">This is required on your first login.</p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <Input
              label="Current Password"
              type="password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
            <Input
              label="New Password"
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="At least 8 characters"
              required
            />
            <Input
              label="Confirm New Password"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="••••••••"
              required
            />

            {error ? <p className="text-sm text-red-400">{error}</p> : null}

            <Button
              type="submit"
              className="w-full"
              disabled={loading || !currentPassword || !newPassword || !confirmPassword}
            >
              {loading ? <LoadingSpinner size="sm" /> : 'Update Password'}
            </Button>

            <Button type="button" variant="secondary" className="w-full" onClick={logout}>
              Logout
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
